<template>
  <div class="row">
    <div
      class="col-sm-12 col-md-4 col-lg-3 col-xl-3 mb-primary"
      v-if="data.length > 0"
      v-for="(profile, rowIndex) in data[0].assigned_bid_form[0].accepted_forms"
      :key="'row' + rowIndex"
    >
      <job-response-card
        ref="componetUpdate"
        :id="id"
        :profile="profile"
        :actions="actions"
        @action-grid-view-table="getAction"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "JobResponseGrid",
  props: ["id", "data", "actions"],
  data(){
    return{
      open : false,
    }
  },

  methods: {
    getAction(row, action, active) {
      this.$emit("getCardAction", row, action, active);
    },
  },

  watch: {

    data: function (oldVal , newVal) {
      // 
      // this.$refs.componetUpdate.open = true;
      this.$hub.$emit("reload-" + this.data);
      
      // if(this.$refs.componetUpdate.open == true)
      // {
      //   
      //    this.$hub.$emit("reload-" + this.data);
      // }
      // else{
      //    this.$refs.componetUpdate.open = false;
      // }
      
    }
  }
};
</script>
